import { render, staticRenderFns } from "./RowVideo.vue?vue&type=template&id=ce80587a&scoped=true&"
import script from "./RowVideo.vue?vue&type=script&lang=js&"
export * from "./RowVideo.vue?vue&type=script&lang=js&"
import style0 from "./RowVideo.vue?vue&type=style&index=0&id=ce80587a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce80587a",
  null
  
)

export default component.exports